import React from 'react'

export default function Footer() {
    return (
        <footer className='bg-[#313E47] p-4 lg:p-10 text-white'>
            <div className='flex flex-col lg:flex-row justify-center gap-5 lg:gap-20'>
                <div className='w-[100%] lg:w-[60%] text-justify'>
                    <span className='uppercase font-semibold '>Disclaimer:</span> The content on this platform is for informational purposes only and does not constitute financial, investment, or legal advice. By using this platform, you acknowledge and agree to our Terms of Service and Privacy Policy.
                </div>
                <div className='w-[100%] lg:w-[20%]'>
                    <h1 className='font-bold'>LINKS</h1>
                    <div className='text-[#8AD5FF] flex flex-col'>
                        <a href='/'>Terms & Conditions</a>
                        <a href='/'>Refund Policy</a>
                        <a href='/'>Privacy Policy</a>
                    </div>
                </div>
            </div>
            <hr className='my-5'></hr>
            <h1 className='text-center'> © {new Date().getFullYear()} Finkey Star. All rights reserved</h1>
        </footer>
    )
}
